/** Kullanıcı baş harfleri (ui.md §12.7): `.` `-` `_` ya da boşlukla bölünür; ≥ 2 parçada ilk iki parçanın ilk harfi, tek parçada ilk iki harf. */
export function initials(name: string): string {
  const parts = name.split(/[.\-_\s]+/).filter(Boolean);
  const [a = "", b] = parts;
  return (b ? a.slice(0, 1) + b.slice(0, 1) : a.slice(0, 2)).toLocaleUpperCase("tr-TR");
}
